/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Pricing_Page_NoteInputs */

const en_mk_pricing_page_note = /** @type {(inputs: Mk_Pricing_Page_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Per seat per month, billed monthly, AI work quota included in every plan. No setup fee and no minimum term.`)
};

const id_mk_pricing_page_note = /** @type {(inputs: Mk_Pricing_Page_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Harga per kursi per bulan, tagihan bulanan, sudah termasuk kuota kerja AI di tiap paket. Tidak ada biaya pemasangan dan tidak ada kontrak minimum.`)
};

/**
* | output |
* | --- |
* | "Per seat per month, billed monthly, AI work quota included in every plan. No setup fee and no minimum term." |
*
* @param {Mk_Pricing_Page_NoteInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_pricing_page_note = /** @type {((inputs?: Mk_Pricing_Page_NoteInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Pricing_Page_NoteInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_pricing_page_note(inputs)
	return en_mk_pricing_page_note(inputs)
});